var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isDataLoading
        ? _c("c-loader", {
            attrs: {
              label: "Загрузка отчётов",
              active: _vm.isDataLoading,
              height: "500",
            },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "reports" },
        [
          _vm._l(_vm.sortedReportsByFavorite, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "reports__chart",
                attrs: { id: `chart-${index}` },
              },
              [
                !_vm.isDataLoading && _vm.dataReportsLocal.length > 0
                  ? [
                      _c(
                        "div",
                        [
                          _c(
                            "div",
                            { staticClass: "reports__chart__header" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "reports__chart__header__title",
                                },
                                [_vm._v(_vm._s(item.titleChart))]
                              ),
                              _c("c-button", {
                                attrs: {
                                  size: "iconic",
                                  icon: "favorites",
                                  tooltip: {
                                    text: "Добавить в избранное",
                                    activeText: "Добавлено в избранное",
                                  },
                                  active: item.isFavorite,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.triggerFavoriteReport(
                                      index,
                                      item.chartName,
                                      item.isFavorite ? 0 : 1
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c("highcharts", {
                            attrs: { options: item.settings },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "c-sidesheet",
                        {
                          attrs: { active: item.isActiveModalFilial },
                          on: {
                            close: function ($event) {
                              return _vm.closeModalFilial(index)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "reports__chart__filial__modal" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "reports__chart__filial__modal__header",
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "reports__chart__filial__modal__header__close",
                                      attrs: {
                                        width: "15",
                                        height: "16",
                                        viewBox: "0 0 15 16",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.closeModalFilial(index)
                                        },
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                                          fill: "#8E9CBB",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                                          fill: "#8E9CBB",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "reports__chart__filial__modal__header__title",
                                    },
                                    [_vm._v(_vm._s(item.titleChart))]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "reports__chart__filial__modal__search",
                                  class: {
                                    reports__chart__filial__modal__search__shadow:
                                      _vm.isScrollableCharts,
                                  },
                                },
                                [
                                  _c("c-input", {
                                    staticClass:
                                      "reports__chart__filial__modal__search__input",
                                    attrs: {
                                      type: "select",
                                      checkbox: true,
                                      "checkbox-type": "icon",
                                      "checkbox-value":
                                        _vm.filialsLocalCheckbox,
                                      "checkbox-tooltip": {
                                        disabledText:
                                          "Фильтр по всем значениям в справочнике, кроме выбранных",
                                        activeText:
                                          "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
                                        notActiveText:
                                          "Включить фильтр по всем значениям в справочнике, кроме выбранных",
                                      },
                                      multiple: true,
                                      searchable: true,
                                      placeholder: "Все филиалы",
                                      items: _vm.getFilialSelectItems(
                                        item.filialDataReports
                                      ),
                                    },
                                    on: {
                                      checkboxChange:
                                        _vm.inputSearchCheckboxChange,
                                    },
                                    model: {
                                      value: _vm.filialsLocalSelect,
                                      callback: function ($$v) {
                                        _vm.filialsLocalSelect = $$v
                                      },
                                      expression: "filialsLocalSelect",
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "reports__chart__filial__modal__search__desc",
                                    },
                                    [
                                      _vm._v(
                                        " При клике на секторе графика вы перейдете на страницу со списком сотрудников, отфильтрованных по этому признаку "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "reports__chart__filial__modal__charts",
                                  attrs: { id: `charts-modal-${index}` },
                                  on: {
                                    scroll: function ($event) {
                                      return _vm.handleChartsScroll(index)
                                    },
                                  },
                                },
                                _vm._l(
                                  item.filialDataReports,
                                  function (filialChart, i) {
                                    return _c(
                                      "div",
                                      {
                                        key: i,
                                        staticClass:
                                          "reports__chart__filial__modal__charts__item",
                                        class: {
                                          reports__chart__filial__modal__charts__item__hidden:
                                            !_vm.isShowFilialDataReportBySearch(
                                              filialChart
                                            ),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "reports__chart__filial__modal__charts__item__title",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(filialChart.filialName)
                                            ),
                                          ]
                                        ),
                                        _c("highcharts", {
                                          attrs: {
                                            options: filialChart.settings,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            )
          }),
          !_vm.isDataLoading && _vm.dataReportsLocal.length === 0
            ? _c("div", { staticClass: "reports__empty" }, [
                _vm._v("Отчёты не найдены"),
              ])
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }